import {createFileRoute} from '@tanstack/react-router';
import {DocumentsPage} from 'pages/support/documents/DocumentsPage';

export const Route = createFileRoute('/_protected/home/service/documents')({
  component: DocumentsPage,
  staticData: {crumbKey: 'navigation.documents'},
});
